import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PopupData } from '../training-parameter-template/training-parameter-template.component';
import { PaginationService } from 'src/app/PaginationService';
import { DynamicAuditTrailComponent } from 'src/app/support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from 'src/app/grid-reorder/grid-reorder.component';
import { EditorComponent } from 'src/app/editor/editor.component';
@Component({
  selector: 'app-badge-ranges',
  templateUrl: './badge-ranges.component.html',
  styleUrls: ['./badge-ranges.component.scss']
})
export class BadgeRangesComponent implements OnInit {

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;
  searchText: any;
  searchValue: any;
  isProcessing: boolean = false;
  _temp: any = {};
  columnLists: any = {};
  badgeRangesList: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];

  constructor(public dialog: MatDialog, readonly appService: AppService, public router: Router, readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, readonly elem: ElementRef) { }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  readonly users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetPage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.badgeRangesList.length, page, this.perPage, targetPage);
    this.pagedItems = this.badgeRangesList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;
  getClobData(list: any, colunName: any, popupColumnName: any) {
    this.isProcessing = true;
    let docObj = {

      primeIdentifier: list.PRIM_IDENTIFIER,
      tableView: list.tablevwname,
      columnName: colunName
    }
    this.htmlContent = "";
    this.appService.getClobToViewAudit(docObj).subscribe({
      next: (Response: any) => {
        console.log(Response.result);
        this.htmlContent = Response.result;
        this.editorComponent.openEditor(this.htmlContent, popupColumnName);
      },
      error: (error) => {
        console.log(error);
      }
    });
    this.isProcessing = false;

  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getCall() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);

    this.badgeRangesList = [];
    const data = {

      gridName: "TRAINING_BADGE"
    };

    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {
        this.processDynamicFields(response, data);
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  processDynamicFields(response: any, originalData: any) {
    response.orderByClause ??= "";
    this.makeStickyColumns = response.fixedFieldCnt;

    const gridMetadata: any = {
      gridName: "TMS_BADGE_RANGES_VW",
      tableOrViewName: response.tableOrViewName ?? "",
      columnsList: response.columnsList ?? "",
      fieldLabelsList: response.fieldLabelsList ?? "",
      invisibleColumn: response.invisibleColumn ?? "",
      orderByClause: response.orderByClause ?? "",
      fieldSizeList: response.fieldSizeList ?? "",
      manualEntryDataFields: response.manualEntryDataFields,
      clobColumnlist: response.closblist || "",
      blobColumnlist: response.bloblist || ""
    };

    this.reportObj = { ...gridMetadata, ...originalData };

    this.appService.getDynamicGridData(gridMetadata).subscribe({
      next: (gridData: any) => {
        this.badgeRangesList = gridData;
        this.visibleAuditTrail = false;
        this.initializeColumnLists(gridMetadata);
        this.fetchTableDataTypes(gridMetadata.tableOrViewName);
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  initializeColumnLists(metadata: any) {
    const columnsListarray = metadata.columnsList.split(",");
    const fieldColumnarray = metadata.fieldLabelsList.split(",");
    const invisibleColumnarray = metadata.invisibleColumn.split(",");
    const fieldSizeListArray = metadata.fieldSizeList.split(",");

    this.columnLists.columnsListarray = columnsListarray;
    this.columnLists.fieldLabelsList = metadata.fieldLabelsList;
    this.columnLists.invisibleColumnarray = invisibleColumnarray;
    this.columnLists.fieldColumnarray = [];
    this.columnLists.fieldSizeListArray = [];

    for (const [index, field] of fieldColumnarray.entries()) {
      const width = Number.parseInt(fieldSizeListArray[index], 10) + 50;
      this.columnLists.fieldColumnarray.push({
        "fieldColumnarray": field,
        "width": width + 'px'
      });
      this.columnLists.fieldSizeListArray.push((Number.parseInt(fieldSizeListArray[index], 10) + 50) + 'px');
    }

    for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
      if (this.columnLists.invisibleColumnarray.includes(this.columnLists.columnsListarray[y])) {
        this.columnLists.columnsListarray.splice(y, 1);
        this.columnLists.fieldColumnarray.splice(y, 1);
        this.columnLists.fieldSizeListArray.splice(y, 1);
      }
    }
  }

  fetchTableDataTypes(tableName: string) {
    const tableData = { tablename: tableName };
    this.columnLists.columnsListarray1 = [];

    this.appService.tableFieldsDataType(tableData).subscribe({
      next: (dataTypes: any) => {
        this.dataTypeList = dataTypes;
        this.mapColumnsAndRows();
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  mapColumnsAndRows() {
    // Map Columns
    for (const col of this.columnLists.columnsListarray) {
      const colObj: any = {
        columnsListarray: col,
        dataType: "textbox",
        width: this.columnLists.fieldSizeListArray
      };

      const matchingType = this.dataTypeList.find((t: any) => t.columnName === col);
      if (matchingType) {
        colObj.dataType = matchingType.fieldType;
      }
      this.columnLists.columnsListarray1.push(colObj);
    }

    for (const row of this.badgeRangesList) {
      for (const type of this.dataTypeList) {
        if (type.fieldType === 'CHECKBOX') {
          row[type.columnName] = row[type.columnName] === "Y";
        }
      }
    }

    this.calculateTotalPages = this.collectionSize / this.perPage;
    this.setPage(1, 0);

    this.message.gridList = this.badgeRangesList;
    this.collectionSize = this.badgeRangesList.length;
    this.totalPages = Math.ceil(this.badgeRangesList.length / this.itemsPerPage);
    this.labelCall();
  }

  ngOnInit() {
    this.isProcessing = true;
    this.getCall()
  }
  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItems = this.badgeRangesList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.badgeRangesList.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }

      index1++;
    })


    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    let p = 1;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          p = p + 1;
          column.style.background = 'white';
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    const isChecked = e.target.checked;
    this.childCheckBoxs = isChecked;

    for (const item of this.badgeRangesList) {
      item.childCheckBoxs = isChecked;
    }
  }

  priviousSelectedValue: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.priviousSelectedValue != undefined) {
        this.badgeRangesList[this.priviousSelectedValue].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.BADGE_NAME;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.badgeRangesList.some((list: any) => list.childCheckBoxs);
    this.priviousSelectedValue = idx;
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;
    this.badgeRangesList.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  badgeRangeData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '60px' },
  };

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.badgeRangeData = {};
    this.badgeRangeData.isActive1 = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = 'Add Training Badge';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }


  visibleAddButton: boolean;
  visibleEditButton: boolean;
  visibleReasonForUpdateField: boolean;
  previousData: any;
  getTmsGroupsVwData: any = [];

  openEditPopup(editRowData: any) {
    this.isProcessing = true;
    this.previousData = editRowData;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.visibleReasonForUpdateField = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update Training Badge";
    this.appService.getBadgeRangeByBadgeName(editRowData.BADGE_NAME).subscribe((response: any) => {
      this.badgeRangeData = response[0];
      this.badgeRangeData.isActive1 = this.badgeRangeData.isActive == "Y";
      this.badgeRangeData.comments = "";
      this.isProcessing = false;
    })
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  refreshGridData() {
    this.isProcessing = true;
    this.getCall();
  }

  config: EditorConfig = {
    placeholder: '',
    buttons: ST_BUTTONS,
  };
  openSnackbar: any;

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    field.style.color = items ? '#005c8a' : 'red';
  }

  validateMandatoryFields(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;
      element.style.color = 'red';
    });
  }

  addAndEditFunction(badgeRange: any) {

    const validations = [
      { condition: !this.badgeRangeData.badgeName, id: 'badge-name-validation' },
      { condition: !this.badgeRangeData.comments, id: 'comments-validation' },
    ]

    const invalidIds = validations.filter((validation) => validation.condition).map((validation) => validation.id);

    if (invalidIds.length > 0) {
      this.validateMandatoryFields(invalidIds);
    } else {
      this.isProcessing = true;
      const data = {
        ...badgeRange,
        isActive: badgeRange.isActive1 ? 'Y' : 'N'
      }

      if (this.operationFlag == 'ADD') {
        this.appService.createBadgeRange(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      } else {
        this.appService.updateBadgeRange(data).subscribe({
          next: (Response: any) => {
            if (Response.resultType == "S") {
              this.ngOnInit();
              this.visibleAddAndEditPopup.close();
              this.showSnackBar(Response.result, Response.resultType);
            } else {
              this.isProcessing = false;
              this.showSnackBar(Response.result, Response.resultType);
            }
          },
          error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  deletingBadge: any;
  openDeletePopup(deleteBadge: any) {
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete Training Badge";
    this.deletingBadge = deleteBadge.BADGE_NAME;
    this.badgeRangeData.deleteReason = "";
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  deleteFunction(badgeData: any) {
    const reason = this.badgeRangeData.deleteReason;
    if (reason === null || reason === undefined || reason.trim().length === 0) {
      const field = document.getElementById('delete-reason-validation') as HTMLInputElement;
      field.style.color = 'red';
    } else {
      this.isProcessing = true;
      const data = {
        badgeName: this.deletingBadge,
        deleteReason: badgeData.deleteReason
      }
      this.appService.deleteBadgeRange(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.getCall();
            this.visibleDeletePopup.close();
            this.showSnackBar(Response.result, Response.resultType);
          } else {
            this.isProcessing = false;
            this.showSnackBar(Response.result, Response.resultType);
          }
        },
        error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel
          ? this.message.breadcrumbData.thirdLevel
          : this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, badge: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : badge.BADGE_NAME;
    this.auditTrail.gridName = 'TRAINING_BADGE';
    this.auditTrail.report_And_Popup_Name = 'Training Badges Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(badge);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'QMS Report Template Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getCall();
  };

  dynamicLabel: any = null;
  label: any = [];
  labelCall() {
    this.isProcessing = true;
    let data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (res: any) => {
        this.label = res;

        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[user.columnName] = user.changedFieldName;
          return acc;
        }, {});

        this.isProcessing = false;
      },
      error: (error: any) => {
        this.isProcessing = false;

      }
    });
  }
}
